/**
 * @file   src\components\MyWantAd\ArchiveModal.js
 * @brief  This file is responsible for archive want ad confirmation popup
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import Modal from "react-bootstrap/Modal";
import { Row, Col, Button } from "react-bootstrap";

const ArchiveModal = (props) => {
  const { show, handleConfirm, onHide } = props;

  return (
    <Modal
      show={show}
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-custom-width"
    >
      <Modal.Body className="pb-32 pt-32">
        <button
          type="button"
          className="btn-close"
          aria-label="Close"
          onClick={onHide}
        ></button>
        <h2 className="text-start f-size-24 mb-2 l-spacing">
          Are you sure you want to pause your want-listing?
        </h2>

        <Row>
          <Col xl={12} className="">
            <p className=" mb-2 f-size-16 text-start">
              Pausing this listing will stop any further introductions from being
              sent to you, and it will be removed from the listing feed.
            </p>
            <p className=" mb-4 f-size-16 text-start">
              You can make your paused want-listing public again when you’re ready to
              receive introductions.
            </p>
          </Col>
          <Col xl={12} className="">
            <div className="modal-btn-wrap">
              <Button
                variant=""
                className="btn btn-tertiary me-3"
                onClick={onHide}
              >
                Cancel
              </Button>
              <Button variant="primary" className="btn" onClick={handleConfirm}>
                Pause My Want-Listing
              </Button>
            </div>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
};
export default ArchiveModal;
